import React, { useRef, useState } from "react";

export default () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [startY, setStartY] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const [scrollTop, setScrollTop] = useState(0);
  const [roomSchameScale, setRoomSchameScale] = useState<number>(1);

  // Obsługa przeciągania myszką
  const handleMouseDown = (e: React.MouseEvent) => {
    if (!containerRef.current || !contentRef.current) return;
    setIsDragging(true);
    setStartX(e.pageX - contentRef.current.offsetLeft);
    setStartY(e.pageY - contentRef.current.offsetTop);
    setScrollLeft(containerRef.current.scrollLeft);
    setScrollTop(containerRef.current.scrollTop);
    containerRef.current.style.cursor = "grabbing";
  };

  const handleMouseUp = () => {
    setIsDragging(false);
    if (containerRef.current) {
      containerRef.current.style.cursor = "grab";
    }
  };

  const handleMouseLeave = () => {
    setIsDragging(false);
    if (containerRef.current) {
      containerRef.current.style.cursor = "grab";
    }

    enableScroll();
  };

  const handleMouseEnter = () => {
    disableScroll();
  };

  const handleMouseMove = (e: React.MouseEvent) => {
    if (!isDragging || !containerRef.current) return;
    e.preventDefault();
    const x = e.pageX - startX;
    const y = e.pageY - startY;
    containerRef.current.scrollLeft = scrollLeft - x;
    containerRef.current.scrollTop = scrollTop - y;
  };

  // Obsługa przeciągania na urządzeniach dotykowych
  const handleTouchStart = (e: React.TouchEvent) => {
    if (!containerRef.current || !contentRef.current) return;
    setIsDragging(true);
    const touch = e.touches[0];
    setStartX(touch.pageX - contentRef.current.offsetLeft);
    setStartY(touch.pageY - contentRef.current.offsetTop);
    setScrollLeft(containerRef.current.scrollLeft);
    setScrollTop(containerRef.current.scrollTop);
    containerRef.current.style.cursor = "grabbing";
  };

  const handleTouchEnd = () => {
    setIsDragging(false);
    if (containerRef.current) {
      containerRef.current.style.cursor = "grab";
    }
  };

  const handleTouchMove = (e: React.TouchEvent) => {
    if (!isDragging || !containerRef.current) return;
    e.preventDefault();
    const touch = e.touches[0];
    const x = touch.pageX - startX;
    const y = touch.pageY - startY;
    containerRef.current.scrollLeft = scrollLeft - x;
    containerRef.current.scrollTop = scrollTop - y;
  };

  // Obsługa zmiany skali za pomocą scrolla
  const handleWheel = (e: React.WheelEvent) => {
    if (!contentRef.current) return;
    e.preventDefault();
    e.stopPropagation();
    const newScale = roomSchameScale - Math.sign(e.deltaY) * 0.05;
    setRoomSchameScale(Math.max(newScale, 0.05));
  };

  const disableScroll = () => {
    document.body.style.overflow = 'hidden';
  };

  const enableScroll = () => {
    document.body.style.overflow = '';
  };

  return {
    containerRef,
    contentRef,
    roomSchameScale,
    setRoomSchameScale,
    handleMouseDown,
    handleMouseUp,
    handleMouseLeave,
    handleMouseMove,
    handleTouchStart,
    handleTouchEnd,
    handleTouchMove,
    handleWheel,
    handleMouseEnter
  };
};
